import { customElement } from 'lit/decorators';
import { css, html, LitElement } from 'lit';
import { center, padding, row } from '../styles';
import CodeIcon from '@carbon/web-components/es/icons/code/16';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { annotation } from './common';

@customElement('pdq-tutorial-perspective-viewer-with-schema')
class PDQTutorialPerspectiveViewerWithSchema extends LitElement {
  static styles = [
    row,
    center,
    padding,
    annotation,
    css`
    `];

  render() {
    const code = `<pdq-json id="people-data">
<script type="application/json" slot="json">
[
  {
    "string": "A",
    "integer": 25.1234,
    "float": 25.1234,
    "datetime": "2021-01-01T00:00:00Z",
    "date": "2021-01-01T00:00:00Z",
    "notInSchema": "This field is not in the schema"
  },
  {
    "string": "B",
    "integer": 25.1234,
    "datetime": "2021-01-01T00:00:00Z",
    "date": "2021-01-01T00:00:00Z",
    "notInSchema": "This field is not in the schema"
  },
  {
    "string": "C",
    "integer": -25.1234,
    "float": -25.1234,
    "datetime": "1001-01-01T00:00:00Z",
    "date": "1001-01-01T00:00:00Z"
  },
  {
    "string": "NULL VALUES",
    "integer": null,
    "float": null,
    "datetime": null,
    "date": null
  },
  {
    "string": 1234,
    "integer": "BAD VALUES",
    "float": "BAD VALUES",
    "datetime": "BAD VALUES",
    "date": "BAD VALUES"
  }
  
]
</script>
</pdq-json>
<pdq-table id="people" source="people-data" schema='{"string": "string", "integer": "integer", "float":"float", "datetime": "datetime", "date": "date"}'></pdq-table>
<pdq-perspective-viewer table="people" height="calc(50vh - 80px)">
`;

    return html`
      <cds-tile>
        <h2>Perspective Table with Schema</h2>
        <p>When a schema is provided the behaviour of perspective changes...</p>
        <pdq-code-html code="${code}"></pdq-code-html>
        ${unsafeHTML(code)}
      </cds-tile>
    `;
  }
}